import http from './http';

/**
 * 访客记录（IP 管理）相关接口
 */

/** 访客列表，params: { start, count } */
export function list(params = {}) {
  return http.get('/api/customer/list', { params });
}

/** 某个 IP 的访问文件列表 */
export function filesByIp(ip, count) {
  return http.get('/api/customer/files', { params: { ip, count } });
}

/** 白名单 IP 列表（'ip1,ip2' 纯文本） */
export function whiteIp(ip) {
  return http.post('/api/customer/whiteip', ip, {
    headers: { 'Content-Type': 'text/plain' },
  });
}

/** 拉黑 IP */
export function blockIp(ip) {
  return http.post('/api/customer/blockip', ip, {
    headers: { 'Content-Type': 'text/plain' },
  });
}

/** 已拉黑 IP 列表（'ip1,ip2,ip3' 纯文本） */
export function blockIpList() {
  return http.get('/api/customer/blockipList', { responseType: 'text' });
}
